import React from 'react';
import { useIntl } from 'react-intl';
import Tag from 'antd/lib/tag';
import { colors } from '../../theme/theme';

type Props = {
  type?: string | null;
};

const FuelTransactionType: React.FC<Props> = ({ type }) => {
  const intl = useIntl();

  if (!type) return <span>-</span>;

  return (
    <Tag
      data-testid={`FuelTransactionType-${type}`}
      style={{
        margin: 0,
        borderColor: '#d3d3d3',
        backgroundColor: colors.background,
        color: colors.black,
        fontSize: 12,
        lineHeight: '20px',
      }}
    >
      {intl.formatMessage({
        id: `fleetadmin.fuelTransactions.type.${type}`,
        defaultMessage: type,
      })}
    </Tag>
  );
};

export default FuelTransactionType;
